var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 42 42"
    },
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.07 8.35c-4.58 4.58-4.58 12.01 0 16.59s12.01 4.58 16.59 0 4.58-12.01 0-16.59c-4.59-4.59-12.01-4.59-16.59 0zm13.65 13.64c-2.96 2.96-7.75 2.96-10.71 0s-2.96-7.75 0-10.71 7.75-2.96 10.71 0 2.95 7.76 0 10.71z",
    className: "st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.32 25.12 8.57 36.87c-.29.29-.77.29-1.06 0l-2.38-2.38a.754.754 0 0 1 0-1.06l11.75-11.75 3.44 3.44z",
    className: "st2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/Magnify.696215bd6553ee84830d6c79d93c8098.svg";
export { ForwardRef as ReactComponent };